export enum VehicleSliceEnum {
	page = 'flmc:payment calculator or estimator',
	rule = 'ford-credit-payment-calculator',
	hierarchy = 'financing:payment calculator or estimator',
	status = 'logged out',
	site_section = 'payment calculator or estimator',
	page_result = 'flmc:payment calculator or estimator:results',
	page_result_rule = 'ford-credit-payment-calculator-onclick',
	trim_page = 'flmc:payment calculator or estimator:select a trim'
}
